import { buildStateEvent, GenericStateEvent } from '../../common-redux'
import { GeneralIncidentSetting } from './model'

export interface GeneralIncidentSettingStateEvent<T> extends GenericStateEvent<T> { }

export const GetAllGeneralIncidentSettingSuccessEvent = {
    type: 'GetAllGeneralIncidentSettingSuccessEvent',
    build: (payload: GeneralIncidentSetting) => buildStateEvent(GetAllGeneralIncidentSettingSuccessEvent.type, payload)
}
